<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="element-header">Time management</h6>
      </div>
      <div class="element-box">
        <div class="d-flex justify-content-between mb-5 flex-md-row flex-column ">
          <h5>Übersicht</h5>
          <div class="btn-group d-flex flex-column flex-md-row">
            <button class="btn rounded btn-primary w-100 mb-2 mb-md-0 "
                    @click="router.push({ name: 'hourlyOverview', params: { id: userId } });">
              Time management
            </button>
            <button class="btn rounded btn-primary w-100 ms-0 ms-md-2"
                    @click="router.push({ name: 'monthlyOverview' });">
              Zurück zur Übersicht
            </button>
          </div>
        </div>

<!--        <h5 class="mb-3 mt-5">{{ overviewList?.data?.user?.fullName }}</h5>-->
<!--        <div class="row">-->
<!--          <div class="col-12 col-lg-4">-->
<!--            <div class="row mb-2">-->
<!--              <div class="col-8 text-start fw-bold">Mitarbeiter seit</div>-->
<!--              <div class="col-4 text-end">-->
<!--                {{ overviewList?.data?.user?.startingDate }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row mb-2">-->
<!--              <div class="col-8 text-start fw-bold">Wöchentliche Arbeitsstunden</div>-->
<!--              <div class="col-4 text-end">{{ overviewList?.data?.user?.workingHours }}</div>-->
<!--            </div>-->
<!--            <div class="row mb-2">-->
<!--              <div class="col-8 text-start fw-bold">Eingetragene Arbeitstage</div>-->
<!--              <div class="col-4 text-end">-->
<!--                <div v-for="(day) in overviewList?.data?.workingDays" :key="day">-->
<!--                  {{ $t('general.weekDays.' + day) }}-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div class="row mb-2">-->
<!--              <div class="col-8 text-start fw-bold">Urlaubsanspruch für das Jahr</div>-->
<!--              <div class="col-4 text-end">{{ overviewList?.data?.holidays }}</div>-->
<!--            </div>-->
<!--            <div class="row mb-2">-->
<!--              <div class="col-8 text-start fw-bold">Resturlaub aus diesem Jahr</div>-->
<!--              <div class="col-4 text-end">{{ overviewList?.data?.totalDaysLeft }}</div>-->
<!--            </div>-->
<!--            <div class="row mb-2">-->
<!--              <div class="col-8 text-start fw-bold">Gesamt verfügbare Überstunden:</div>-->
<!--              <div class="col-4 text-end">{{ overviewList?.data?.retroactiveOvertimeHours }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="holiday_user_data mb-3">
          <h5 class="pb-3">{{ overviewList?.data?.user?.fullName }}</h5>

          <div class="clearfix mb-2"></div>
          <div class="row mb-1">
            <div class="col-lg-3 col-md-6 col-sm-12">
              Mitarbeiter seit:
            </div>
            <div class="col-auto">
              {{ overviewList?.data?.user?.startingDate }}
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-3 col-md-6 col-sm-12">
              Eingetragene Arbeitstage:
            </div>
            <div class="col-auto">
             <span style="float: left; text-align: left;">
               <span v-for="(day, index) in overviewList?.data?.workingDays" :key="day">
                 {{ $t('general.weekDays.' + day) }}<span
                   v-if="index < overviewList.data.workingDays.length - 1">, </span>
               </span>
             </span>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-3 col-md-6 col-sm-12">
              Wöchentliche Arbeitsstunden
            </div>
            <div class="col-auto">
              {{ overviewList?.data?.user?.workingHours }}
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-3 col-md-6 col-sm-12">
              Urlaubsanspruch für das Jahr
            </div>
            <div class="col-auto">
              {{ overviewList?.data?.holidays }}
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-3 col-md-6 col-sm-12">
              Resturlaub aus diesem Jahr
            </div>
            <div class="col-auto">
              {{ overviewList?.data?.totalDaysLeft }}
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-3 col-md-6 col-sm-12">
              Gesamt verfügbare Überstunden:
            </div>
            <div class="col-auto">
              {{ overviewList?.data?.retroactiveOvertimeHours }}
            </div>
          </div>
      </div>

      <div class="col-lg-2 col-md-4 col-sm-12 p-0 mt-4">
        <div v-if="yearsDropdown && yearsDropdown.length">
          <SelectVue v-model="filters.year" :options="yearsDropdown"/>
        </div>
      </div>

      <div class="table-responsive overflow-auto">
        <table class="table table-striped">
          <thead>
          <tr>
            <th style=" text-align: left; padding-right: 30px; min-width: 150px;">{{ $t('general.actions') }}</th>
            <th>Monat</th>
            <th class="text-end">Arbeitszeit</th>
            <th class="text-end">Soll</th>
            <th class="text-end">Überstunden</th>
            <th class="text-end">davon im Büro</th>
            <th class="text-end">Arbeitsleistung %</th>
            <th class="text-end">Urlaub</th>
            <th class="text-end">Sonderurlaub</th>
            <th class="text-end">Krankheitstage</th>
            <th class="text-end">Abgehaltene Einheiten</th>
            <th class="text-center">Eingereicht zur Überprüfung</th>
            <th class="text-center">Akzepiert</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(month, index) in overviewList?.data?.months" :key="month.id">
            <td>
              <button @click="
                      router.push({
                          name: 'hourlyOverview',
                          params: { id: userId },
                          query: { year: overviewList?.data?.overviewYear, month: index + 1 }
                      });
                  " class="btn btn-primary">
                Time management
              </button>
            </td>
            <td>{{ month?.nameTranslation }}</td>
            <td class="text-end">{{ month?.workedHours }}</td>
            <td class="text-end">{{ month?.planedHours }}</td>
            <td class="text-end">{{ month?.overtimeHours }}</td>
            <td class="text-end">{{ month?.recalculatedPlanedHours }}</td>
            <td class="text-end">{{ month?.workPerformance }}</td>
            <td class="text-end">{{ month?.numberOfVacationDays }}</td>
            <td class="text-end">{{ month?.numberOfSpecialLeaveDays }}</td>
            <td class="text-end">{{ month?.numberOfSickDays }}</td>
            <td class="text-end">{{ month?.unitsDone }}</td>
            <td class="text-center">
                <span v-if="hasRoleAdminOrPersonal && month.pendingRequest"
                      style="background-color: orange; padding: 9px 14px; border-radius: 50%;">!</span>
            </td>
            <td class="text-center">
                <span v-if="hasRoleAdminOrPersonal && month.approvedRequest"
                      style="background-color: #43ad4e; color: white; padding: 9px 12px; border-radius: 50%;">✓</span>
            </td>
          </tr>
          <tr>
            <td style="text-align: left;">Jahresübersicht</td>
            <td></td>
            <td class="text-end">{{ overviewList?.data?.totalWorkedHoursForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalPlanedHoursForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalOvertimeHoursForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalRecalculatedPlanedMinutesForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalWorkPerformance }} %</td>
            <td class="text-end">{{ overviewList?.data?.totalVacationDaysForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalSpecialLeaveDaysForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalIllDaysForYear }}</td>
            <td class="text-end">{{ overviewList?.data?.totalUnitsDoneForYear }}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>Gesamt verfügbare <br>Überstunden:</td>
            <td></td>
            <td></td>
            <td class="text-end">{{ overviewList?.data?.retroactiveOvertimeHours }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
      <Pagination v-if="overviewList?.pagination?.total_pages > 1"
                  :totalPages="overviewList?.pagination?.total_pages"
                  :currentPage="overviewList?.pagination?.current_page"
                  @pagechanged="getOverview"/>
    </div>
    </div>
  </PageTemplate>
</template>

<script setup>
import {timeManagementService} from '@/api/TImeManagement';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import SelectVue from '@/components/SelectVue.vue';

import {CloseToast, ErrorToast} from '@/components/VueToast';
import router from '@/router';
import {getUsersForHrOverviewDropdown, getYears} from '@/shared/dropdowns';

import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import {computed, onMounted, ref, watch} from 'vue';
import {useRoute} from 'vue-router';

const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const route = useRoute();
const userId = route.params.id; // Access the "id" parameter
const yearsDropdown = ref([]);
const overviewDropdown = ref([]);
const {enums} = piniaEnumsStore();
const isLoaded = ref(false);
const overviewList = ref([]);
const filters = ref({
  userId: '',
  year: overviewList.value?.data?.overviewYear || new Date().getFullYear(),
  month: enums.monthsInYear[0].value,
});

const allowedRolesForActions = ['ROLE_ADMIN', 'ROLE_PERSONAL', 'ROLE_HEAD_OF_HR'];

const hasRoleAdminOrPersonal = computed(() => {
  return allowedRolesForActions.some(role => piniaCurrentUser.value.roles.includes(role))
});

async function getOverviewData() {
  CloseToast();
  try {
    const {data} = await timeManagementService.getOverview(
        filters.value.year || new Date().getFullYear(), userId || '');

    overviewList.value = data;

  } catch (error) {
    await ErrorToast(error);
  }
}

watch(() => filters.value.year,
    async (newYear) => {
      if (newYear) {
        await getOverviewData();
      }
    },
);

onMounted(async () => {
  await Promise.all([
    getYears(yearsDropdown),
    getOverviewData(),
    getUsersForHrOverviewDropdown(overviewDropdown),
  ]);

  isLoaded.value = true;
});
</script>

<style scoped>
.nav.sm {
  width: max-content;
}
</style>